/**
 * Deterministic clock.
 *
 * Package rule (quality/SECURITY_PRIVACY_AI_AND_ACCESSIBILITY.md):
 * "Scheduled permissions and expiry are evaluated against deterministic time
 * fixtures." Nothing in the application may call `Date.now()` directly.
 */

/** The fixed demo instant every fixture is authored against: 2026-07-27T09:00:00Z. */
export const DEMO_EPOCH_ISO = '2026-07-27T09:00:00.000Z';

let currentIso: string = DEMO_EPOCH_ISO;

export function now(): Date {
  return new Date(currentIso);
}

export function nowIso(): string {
  return currentIso;
}

export function nowMs(): number {
  return new Date(currentIso).getTime();
}

/** Demo control: jump the deterministic clock (used to expire permissions/SCA). */
export function setNow(iso: string): void {
  currentIso = new Date(iso).toISOString();
}

export function advanceMinutes(minutes: number): void {
  currentIso = new Date(nowMs() + minutes * 60_000).toISOString();
}

export function resetClock(): void {
  currentIso = DEMO_EPOCH_ISO;
}
